<dx-popup
    [(visible)]="visible"
    [showTitle]="true"
    title="แก้ข้อมูล 1688"
    [dragEnabled]="true"
    [hideOnOutsideClick]="!saving"
    [width]="1060"
    maxWidth="96vw"
    height="auto"
    maxHeight="90vh"
>
    <dx-scroll-view height="100%">
        <div class="editor">
            <div>
                <b>{{ target?.sku }}</b> · {{ target?.title }}
            </div>

            @for (row of latestRows; track $index) {
            @if (row.matchNote) {
            <div class="match-note">ข้อสังเกตจากการ match: {{ row.matchNote }}</div>
            }
            }

            <table class="parts">
                <thead>
                    <tr>
                        <th>ลิงก์ offer</th>
                        <th>ตัวเลือกที่ต้องกด</th>
                        <th title="เว้นว่างสำหรับตัวหลัก ใส่ชื่อเมื่อเป็นส่วนประกอบของชุด เช่น ฐานรีเลย์">
                            ส่วนประกอบ
                        </th>
                        <th class="num" title="1 หน่วยในร้าน เท่ากับกี่หน่วยบน 1688">
                            ต่อหน่วยในร้าน
                        </th>
                        <th class="num" title="ราคาต่อหน่วยบน 1688 เว้นว่างเพื่อใช้ราคาล่าสุดที่เคยจ่ายให้ตัวเลือกนี้">
                            ¥ ต่อหน่วย 1688
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (part of draftParts; track part) {
                    <tr>
                        <td>
                            <dx-text-box
                                [(value)]="part.link"
                                valueChangeEvent="input"
                                placeholder="วางลิงก์ 1688"
                                [isValid]="isLinkValid(part)"
                                (onValueChanged)="onLinkChanged(part)"
                            ></dx-text-box>
                        </td>
                        <td>
                            <dx-text-box
                                [(value)]="part.label"
                                valueChangeEvent="input"
                                [isValid]="isLabelValid(part)"
                            ></dx-text-box>
                        </td>
                        <td>
                            <dx-text-box
                                [(value)]="part.partName"
                                valueChangeEvent="input"
                            ></dx-text-box>
                        </td>
                        <td class="num">
                            <dx-number-box
                                [value]="part.packQty"
                                [min]="1"
                                format="#,##0"
                                [showSpinButtons]="false"
                                (onValueChanged)="part.packQty = $event.value ?? 1"
                            ></dx-number-box>
                        </td>
                        <td class="num">
                            <dx-number-box
                                [value]="$any(part.unitPriceCny)"
                                [min]="0"
                                format="#,##0.00"
                                [showSpinButtons]="false"
                                [placeholder]="pricePlaceholder(part)"
                                (onValueChanged)="
                                    part.unitPriceCny = $event.value ?? null
                                "
                            ></dx-number-box>
                        </td>
                        <td>
                            <dx-button
                                icon="trash"
                                stylingMode="text"
                                hint="ลบแถวนี้"
                                [disabled]="draftParts.length === 1"
                                (onClick)="removePart(part)"
                            ></dx-button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
            <div>
                <dx-button
                    icon="add"
                    text="เพิ่มส่วนประกอบ"
                    stylingMode="text"
                    (onClick)="addPart()"
                ></dx-button>
            </div>

            <div class="shop-row">
                @if (addingShop) {
                <dx-text-box
                    label="ลิงก์ร้าน เช่น https://vks888.1688.com"
                    labelMode="floating"
                    [(value)]="newShopLink"
                    valueChangeEvent="input"
                    [isValid]="isShopValid"
                    [width]="340"
                ></dx-text-box>
                <dx-text-box
                    label="ชื่อร้านภาษาอังกฤษ"
                    labelMode="floating"
                    [(value)]="newShopName"
                    valueChangeEvent="input"
                    [isValid]="isNewShopNameValid"
                    [width]="240"
                ></dx-text-box>
                <dx-button
                    stylingMode="text"
                    text="เลือกจากร้านที่มี"
                    (onClick)="addingShop = false"
                ></dx-button>
                } @else {
                <dx-select-box
                    label="ร้าน"
                    labelMode="floating"
                    [items]="shopItems"
                    valueExpr="value"
                    displayExpr="text"
                    [searchEnabled]="true"
                    [isValid]="isShopValid"
                    [width]="340"
                    [(value)]="shopUrl"
                ></dx-select-box>
                <dx-button
                    icon="add"
                    stylingMode="text"
                    text="ร้านใหม่"
                    (onClick)="addingShop = true"
                ></dx-button>
                }
            </div>

            <dx-text-box
                label="หมายเหตุ (ไม่บังคับ)"
                labelMode="floating"
                [(value)]="note"
                valueChangeEvent="input"
            ></dx-text-box>

            @if (earlierRows.length > 0) {
            <div>
                <div class="section-title">เคยซื้อก่อนหน้านี้</div>
                <table class="earlier-rows">
                    <tbody>
                        @for (row of earlierRows; track $index) {
                        <tr>
                            <td class="date">{{ row.lastOrderDate }}</td>
                            <td class="label">
                                <a
                                    [href]="row.url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    [title]="row.offerTitle"
                                    >{{ row.specLabel ?? row.offerTitle }}</a
                                >
                            </td>
                            <td class="num">
                                ¥{{ row.costPerStoreUnitCny | formatNumber : 2 }}
                            </td>
                            <td class="use">
                                <dx-button
                                    stylingMode="outlined"
                                    text="ใช้อันนี้"
                                    (onClick)="useEarlierRow(row)"
                                ></dx-button>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            }

            <div class="actions">
                @if (override) {
                <dx-button
                    stylingMode="text"
                    text="กลับไปใช้ค่าที่ match มา"
                    hint="ลบค่าที่ตั้งเองของสินค้านี้"
                    [disabled]="saving"
                    (onClick)="useMatched()"
                ></dx-button>
                }
                <dx-button
                    stylingMode="text"
                    text="ไม่ได้ซื้อจาก 1688"
                    hint="สินค้านี้ซื้อจากที่อื่น ไม่ต้องแสดงลิงก์"
                    [disabled]="saving"
                    (onClick)="markNotOn1688()"
                ></dx-button>
                @if (canConfirm) {
                <dx-button
                    stylingMode="outlined"
                    text="ข้อมูลที่ match ถูกต้องแล้ว"
                    hint="เอาป้าย ตรวจ ออก โดยไม่เปลี่ยนค่า ถ้ามีออเดอร์จาก offer อื่นในอนาคตจะถามใหม่"
                    [disabled]="saving"
                    (onClick)="confirmMatch()"
                ></dx-button>
                }
                <div class="spacer"></div>
                <dx-button
                    stylingMode="outlined"
                    text="ยกเลิก"
                    [disabled]="saving"
                    (onClick)="close()"
                ></dx-button>
                <dx-button
                    stylingMode="contained"
                    type="default"
                    text="บันทึกเป็นค่าที่ตั้งเอง"
                    hint="sync จะไม่เขียนทับค่านี้"
                    [disabled]="saving"
                    (onClick)="save()"
                ></dx-button>
            </div>
        </div>
    </dx-scroll-view>
</dx-popup>
